import { Route, Redirect } from 'react-router-dom';
import { tokenUtils } from '../utils';

function AdminRoute({ children, ...rest }) {
  const isAdmin = tokenUtils.parseJwtAdmin(tokenUtils.getToken());
  return (
    <Route {...rest}>
      {isAdmin ? (
        children
      ) : (
        <Redirect
          to={{
            pathname: '/login',
          }}
        />
      )}
    </Route>
  );
}

export default AdminRoute;
